// src/pages/PermisPage.js

import React from 'react';
import { Link } from 'react-router-dom';
import './Permis.css';
import { FaPassport, FaCar, FaFileAlt, FaGraduationCap } from 'react-icons/fa';

function Permis() {
  const steps = [
    {
      icon: <FaPassport />,
      title: "Documents Requis",
      items: [
        "Permis de conduire B (minimum 1 an)",
        "Permis de séjour valide",
        "Extrait du casier judiciaire",
        "Contrôle de la vue"
      ]
    },
    {
      icon: <FaGraduationCap />,
      title: "Formation",
      items: [
        "Cours théoriques",
        "Entraînement pratique",
        "Apprentissage des règlements",
        "Préparation aux examens"
      ]
    },
    {
      icon: <FaFileAlt />,
      title: "Examens",
      items: [
        "Examen théorique",
        "Examen pratique",
        "Obtention du permis B121",
        "Certification OTR 2"
      ]
    },
    {
      icon: <FaCar />,
      title: "Début d'Activité",
      items: [
        "Transport professionnel",
        "Formation continue",
        "Respect des normes OTR 2",
        "Suivi professionnel"
      ]
    }
  ];

  return (
    <main className="permis-page">
      {/* Hero Section */}
      <section className="permis-hero">
        <div className="hero-content">
          <h1>Permis B121</h1>
          <p>Transport Professionnel de Personnes</p>
        </div>
      </section>

      {/* Introduction */}
      <section className="permis-intro">
        <div className="container">
          <h2>Qu'est-ce que le Permis B121 ?</h2>
          <p>
            Le permis B121 est la certification suisse obligatoire pour le transport 
            professionnel de personnes. Il permet aux chauffeurs d'exercer légalement 
            leur activité et garantit un service de qualité aux clients.
          </p>
        </div>
      </section>

      {/* Steps Grid */}
      <section className="permis-steps">
        <div className="container">
          <div className="steps-grid">
            {steps.map((step, index) => (
              <div key={index} className="step-card">
                <div className="step-header">
                  <span className="step-icon">{step.icon}</span>
                  <h3>{step.title}</h3>
                </div>
                <ul className="step-list">
                  {step.items.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="permis-cta">
        <div className="container">
          <h2>Prêt à Commencer ?</h2>
          <p>
            Rejoignez TaxiVD et bénéficiez d'un accompagnement professionnel 
            pour l'obtention de votre permis B121
          </p>
          <div className="cta-buttons">
            <a href="tel:+41797774444" className="btn-secondary">
              +41 79 777 44 44
            </a>
            <Link to="/quote" className="btn-primary">
              Nous Contacter
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}

export default Permis;
